import { effect, Injectable, signal } from '@angular/core';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  showLoader = signal(false);
  startAuthenticationLoader = signal(false);
  constructor(private commonService: CommonService) {
    // effect(() => {
    //   if (this.showLoader() && this.commonService.isBrowser) {
    //     this.commonService.isBrowser
    //       ? document.body.classList.add('no-scroll')
    //       : '';
    //   } else {
    //     this.commonService.isBrowser
    //       ? document.body.classList.remove('no-scroll')
    //       : '';
    //   }
    // });
  }

  setTimerLoader(visibility: boolean) {
    this.startAuthenticationLoader.set(visibility)
  }

}
